import { DispatchListDetailsRes } from '@zonofi/zono-money-store';
import { ReactComponent as CityIcon } from '@zonofi/svg-icons/city-name.svg';
import { ReactComponent as PincodeIcon } from '@zonofi/svg-icons/pincode.svg';
import { ReactComponent as LocationPinIcon } from '@zonofi/svg-icons/location-pin-icon.svg';

interface DestinationDetailsProps {
  dispatchNoteDetails: DispatchListDetailsRes;
}

export const DestinationDetails = (props: DestinationDetailsProps) => {
  const { dispatchNoteDetails } = props;
  return (
    <div className="dispatch-note-detail-box font-regular">
      <span className="dispatch-note-detail-box-heading font-semibold">
        Destination
      </span>
      <div className="dispatch-note-detail-box-content">
        <CityIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            City Name:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {dispatchNoteDetails.destinationCity || 'N/A'}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <PincodeIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Pincode:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {dispatchNoteDetails.destinationZipCode || 'N/A'}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <LocationPinIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Address:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {dispatchNoteDetails.destinationAddress || 'N/A'}
          </span>
        </div>
      </div>
    </div>
  );
};
